import React from 'react';
import { Image } from 'semantic-ui-react';
import closeIcon from '../../assets/images/White/cancel.svg';

const ToasterCloseIcon = () => {
  return <Image src={closeIcon} />;
};

export default ToasterCloseIcon;
